module.exports = __webpack_public_path__ + "img/PW.7de51bca.png";